(function(angular){
	'use strict';

	angular
		.module('offeringCircularsModule', [
			'campaignCtaModule',
			'coreModule',
			'localStorageModule'
		])
		.value('globalConfig', globalConfig);
})(window.angular);